import { AccountClosureReason } from '__generated__/GQL';
import useSessionStorage from 'common/hooks/useSessionStorage';

import { REASONS_KEY } from '../../constants';
import { AccountClosureFormValues } from '../../types';

type StoredFormValues = Omit<AccountClosureFormValues, 'reasons'> & {
  reasons: AccountClosureReason[];
};

export const useSessionStoredFormValues = () => {
  const [storedValues, storeValues] =
    useSessionStorage<StoredFormValues>(REASONS_KEY);

  const storeFormValues = (formValues: AccountClosureFormValues) => {
    storeValues({
      ...formValues,
      reasons: Array.from(formValues.reasons),
    });
  };

  const getStoredFormValues = (): AccountClosureFormValues | undefined => {
    if (storedValues) {
      return {
        ...storedValues,
        reasons: new Set(storedValues.reasons),
      };
    }

    return undefined;
  };

  return {
    getStoredFormValues,
    storeFormValues,
  };
};
